import React from 'react';

class PartnerWithUsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showContent: false,
      partnerArray: [],
    };
  }

  componentDidMount() {
    this.props.partnerData.forEach((partnerContent) => {
      if (!Array.isArray(partnerContent.content)) {
        this.setState({
          [partnerContent.acf_fc_layout]: partnerContent.content,
        });
      } else {
        this.setState({
          partnerArray: partnerContent,
        });
      }
    });
    this.setState({
      showContent: true,
    });
  }

  render() {
    return (
      <>
        {this.state.showContent
          ? (
            <section className={!this.props.blurBackground ? "background-fade" : "" }>
            <div className="container-fluid partner-img">
              <div className="container partner-container">
                <div className="row">
                  <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                    <div dangerouslySetInnerHTML={{ __html: this.state.hero_text_block }} />
                  </div>
                  <div className="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                    <div dangerouslySetInnerHTML={{ __html: this.state.text_block }} />
                  </div>
                </div>
                <div className="row">
                  <div className="card-deck">
                    {this.state.partnerArray.content.map((partnerCard, i) => (
                          <div
                            className="card partner-cards" key={i}
                            dangerouslySetInnerHTML={{ __html: partnerCard.content }}>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
            </section>
          ) : null}
      </>
    );
  }
}
export default PartnerWithUsComponent;
